module.exports = __webpack_public_path__ + "static/media/empty-token.e8aa64c5.png";